import React from "react";
import { motion } from "framer-motion";

/**
 * Shared design tokens, motion primitives and brand assets for the
 * MatiMitra Carbon Solutions landing experience.
 */

export const BRAND_GREEN = "#1F7A40";
export const BRAND_GREEN_DEEP = "#155C30";

export const easeOutExpo = [0.16, 1, 0.3, 1];

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_utkal-carbon/artifacts/t527eldp_20260130_122936%20%281%29.jpg";

export const UTKAL_IMAGE =
  "https://customer-assets.emergentagent.com/job_utkal-carbon/artifacts/osca77di_20260428_102308%20%281%29.jpg";

export const SOIL_HEALTH_IMAGE =
  "https://customer-assets.emergentagent.com/job_utkal-carbon/artifacts/4xoo8buv_20260427_171631%20%281%29.jpg";

export const BIOCHAR_PRODUCTION_IMAGE =
  "https://customer-assets.emergentagent.com/job_utkal-carbon/artifacts/kd3bajtu_20260129_142942%20%281%29.jpg";

export const RURAL_INCOME_IMAGE =
  "https://customer-assets.emergentagent.com/job_utkal-carbon/artifacts/tfv0t582_Copy%20of%20IMG-20260121-WA0003.jpg";

export const CONTACT_IMAGE =
  "https://customer-assets.emergentagent.com/job_utkal-carbon/artifacts/9o9w1lt2_20260130_1526491.jpg";

export const WORK_IMAGE =
  "https://customer-assets.emergentagent.com/job_utkal-carbon/artifacts/hubxddfi_WhatsApp%20Image%202026-06-15%20at%2018.42.08%20%281%29.jpeg";

export const LOGO_FIXED =
  "https://customer-assets.emergentagent.com/job_utkal-carbon/artifacts/smef2xdz_image.png";

export const NAV_LINKS = [
  { label: "Home", href: "#hero" },
  { label: "About", href: "#about" },
  { label: "What we do", href: "#work" },
  { label: "Contact", href: "#contact" },
];

export const COMPANY_LINKEDIN = "https://www.linkedin.com/company/matimitra-carbon/";
export const FOUNDER_LINKEDIN = "https://www.linkedin.com/in/akash-bisoyi";

export const INQUIRY_OPTIONS = [
  { value: "carbon_credit_buyer", label: "Carbon Credit Buyer" },
  { value: "impact_investor", label: "Impact Investor" },
  { value: "csr_program", label: "CSR Program" },
];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* Motion primitive: in-view reveal with editorial easing. */
export const Reveal = ({
  children,
  delay = 0,
  y = 36,
  duration = 1.1,
  amount = 0.15,
  className = "",
  as = "div",
  ...rest
}) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration, delay, ease: easeOutExpo }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};
